import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../../hooks";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { Button, CopyToClipboard, LogoLoader, NewTableAdv, SmartTooltip, StatusTags, TableAdv } from "../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../utils";
import { fetchAllJobs } from "../../../../../redux/slices/accountDetails/accountDetailsAPi";
import { convertFromUTC } from "../../../../../utils/dateUtils";
import { formatWords2 } from "../../../../../utils/stringUtils";

const JobStatus={
    1:"Active",
    2:"Postive",
    3:"Open",
    4:"On Hold",  
    5:"Hold by Client",
    6:"Interview L1",
    7:"Interview L2",
    8:"Interview L3",
    9:"Priority",
    10:"Filled",
    11:"Closed",
    12:"Agreement Sent",
    13:"Agreement Accepted",
}
const Jobs = ({companyId}) => {
  const dispatch = useDispatch();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { value } = useSelector((state) => state?.totalCount);
  const { page, limit, setPage, handleLimitChange } = usePagination(
      10,
      (newPage, newLimit) => {}
    );
  const totalCount = value?.allCompanyJobs?.data || 0;

  const columns = [
    {
      key: "title",
      label: "Job Title",
    },
    {
      key: "location",
      label: "Job Location",
    },
     {
      key: "jobStatus",
      label: "Status",
      width: 220,
      render: (row) => {
        return (
          <div className="w-[180px] min-w-[160px]">
            <StatusTags
              icon
              size="md"
              tag={JobStatus[row?.status] || ""}
            />
          </div>
        );
      },
    },
    {
      key: "jobDescription",
      label: "Job Description",
      render: (row) => {
        const { description } = row;
        return description ? (
          <a
            href={description}
            target="_blank"
            rel="noopener noreferrer"
            className="text-info"
          >
            Job Description
          </a>
        ) : (
          ""
        );
      },
    },
    {
          key: "addedBy",
          label: "Created By",
          render: (row) => row?.addedBy?.firstName || "-",
        },
        {
          key: "addedOn",
          label: "Created On",
          render: (row) =>
            row?.addedOn ? (
              <div>
                {dateFormator(convertFromUTC(row?.addedOn))}
              </div>
            ) : (
              "-"
            ),
        },
    
        {
          key: "modifiedOn",
          label: "Modified On",
          render: (row) => {
            return <div>{dateFormator(convertFromUTC(row?.modifiedOn))}</div>;
          },
        },
        {
          key: "modifiedBy",
          label: "Modified By",
          render: (row) => {
            return <div>{row?.modifiedBy?.firstName || "-"}</div>;
          },
        },
  ];

  // const rows = Array.from({ length: 5 }, (_, i) => ({
  //   name: "Ershad",
  //   emailId: "vamshi@Tektree.inc",
  //   phoneNumber: "998998888",
  //   jobTitle: "Frontend Developer",
  //   experience: 3,
  //   workAuthorization: "USA",
  //   location: "Dallas",
  // }));
    const rows = jobs.map((item) => ({
      title: formatWords2(item?.title || "-"),
      // location: item?.location
      //   ? `${item?.location?.city || ""}, ${item?.location?.state || ""}, ${item?.location?.country || ""}`
      //   : "-",
      location: item?.location
        ? [item.location?.city, item.location?.state, item.location?.country]
          .filter(Boolean)
          .join(", ")
        : "-",
      status : item?.status || "",
      description: item?.description || "",
      addedOn: item?.addedOn || "-",
      addedBy: formatWords2(item?.addedBy || "-"),
      modifiedOn: item?.modifiedOn || "-",
      modifiedBy: formatWords2(item?.modifiedBy || "-")
    }));

  const mappedRows = mapTableRows(rows, columns);
  useEffect(() => {
    const loadJobs = async () => {
      if(!companyId) {
        showToast("Company ID is missing","error");
        return;
      }
      try {
        setLoading(true);
        const response = await fetchAllJobs({
          coll: "Job",
          fil: { companyId: { type: "NONE", value: companyId } },
          pg: page,
          lim: limit,
          ret: "uiid title addedBy location status description modifiedBy modifiedOn addedOn",
          extret: "uiid firstName"
        });

        if (response?.data?.data?.length) {
          setJobs(response.data.data);
        } else {
          setJobs([]);
        }
      } catch (error) {
        console.error("Error fetching prospects:", error);
        setJobs([]);
      } finally {
        setLoading(false);
      }
    };
    dispatch(
      totalCountStart({
        collection: "jobs",
        coll: "Job",
        tname: "allCompanyJobs",
        filters: { companyId: { type: "NONE", value: companyId } },
        app: "ats",
      })
    );

  loadJobs();
}, [dispatch, limit, page,companyId]);

  if (loading) {
      return (
        <div className="flex items-center justify-center h-64">
          <LogoLoader />
        </div>
      );
    }

  return (
    <div>
      <TableAdv
        columns={columns}
        showSlNo
        showCheckbox
        serverPagination={true}
        totalCount={totalCount}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        tableId={"accountdetails_jobs"}
        onLimitChange={handleLimitChange}
        rows={mappedRows}
        toolbarRight={{
          search: true,
          filter: false,
          download: false,
        }}
      />
    </div>
  );
};

export default Jobs;
